import Axios from 'axios';
import {APIBASE_URL, LOAN} from '../config/cacheKey';
import {ApiResultModel} from '../models/common.model';
import {
    GetSummaryOfInProgressLoansResponse,
    IGetCustomerInfoForInquiryResponse,
    IGetInProgressLoanTemplateResponse,
    IGetLoanTemplatesResponse,
    ILoanDetailResponse,
    IRegisterLoanAndInquiryRequest,
    IRegisterLoanAndInquiryResponse,
    IRegisterLoanResponse,
} from '../models/loan.model';
import {
    IAddCustomerInfoForInquiryRequest,
    ICalculateLoanParamsRequest,
    IGetLoansInfoResponse,
    IGetLoansResponse,
    IRefrenceKeyRequest,
} from '../models/registration.model';

export const registerLoan = (
    data: ICalculateLoanParamsRequest
): Promise<IRegisterLoanResponse> => {
    return Axios.post<ApiResultModel<IRegisterLoanResponse>>(
        APIBASE_URL + LOAN + '/RegisterLoan',
        data
    ).then((result) => {
        return result.data.data;
    });
};
export const registerLoanAndInquiry = (
    data: IRegisterLoanAndInquiryRequest
): Promise<IRegisterLoanAndInquiryResponse> => {
    return Axios.post<ApiResultModel<IRegisterLoanAndInquiryResponse>>(
        APIBASE_URL + LOAN + '/RegisterLoanAndInquiry',
        data
    ).then((result) => {
        return result.data.data;
    });
};

export const addCustomerInfoForInquiry = (
    data: IAddCustomerInfoForInquiryRequest
): Promise<boolean> => {
    return Axios.post<ApiResultModel<boolean>>(
        APIBASE_URL + LOAN + '/AddCustomerInfoForInquiry',
        data
    ).then((result) => {
        return result.data.data;
    });
};
export const getCustomerInfoForInquiry = (
    data: IRefrenceKeyRequest
): Promise<IGetCustomerInfoForInquiryResponse> => {
    return Axios.post<ApiResultModel<IGetCustomerInfoForInquiryResponse>>(
        APIBASE_URL + LOAN + '/GetCustomerInfoForInquiry',
        data
    ).then((result) => {
        return result.data.data;
    });
};

export const GetLoans = async (): Promise<IGetLoansResponse[]> => {
    return await Axios.post<ApiResultModel<IGetLoansResponse[]>>(
        APIBASE_URL + LOAN + '/GetLoans'
    ).then((result) => {
        return result.data.data;
    });
};

export const GetLoanInfo = (
    data: IRefrenceKeyRequest
): Promise<IGetLoansInfoResponse> => {
    return Axios.post<ApiResultModel<IGetLoansInfoResponse>>(
        APIBASE_URL + LOAN + '/GetLoanInfo',
        data
    ).then((result) => {
        return result.data.data;
    });
};

export const GetLoanDetail = (
    data: IRefrenceKeyRequest
): Promise<ILoanDetailResponse> => {
    return Axios.post<ApiResultModel<ILoanDetailResponse>>(
        APIBASE_URL + LOAN + '/GetLoanDetails',
        data
    ).then((result) => {
        return result.data.data;
    });
};

export const CancelLoan = (data: IRefrenceKeyRequest): Promise<boolean> => {
    return Axios.post<ApiResultModel<boolean>>(
        APIBASE_URL + LOAN + '/CancelLoan',
        data
    ).then((result) => {
        return result.data.data;
    });
};
export const GetSummaryOfInProgressLoans = (): Promise<
    GetSummaryOfInProgressLoansResponse[]
> => {
    return Axios.post<ApiResultModel<GetSummaryOfInProgressLoansResponse[]>>(
        APIBASE_URL + LOAN + '/GetSummaryOfInProgressLoans'
    ).then((result) => {
        return result.data.data;
    });
};
export const GetSummaryOfOnlinePaymentLoans = (): Promise<
    GetSummaryOfInProgressLoansResponse[]
> => {
    return Axios.post<ApiResultModel<GetSummaryOfInProgressLoansResponse[]>>(
        APIBASE_URL + LOAN + '/GetSummaryOfOnlinePaymentLoans'
    ).then((result) => {
        return result.data.data;
    });
};
export const GetLoanTemplates = (data: {
    loanTemplateKey?: string;
}): Promise<IGetLoanTemplatesResponse[]> => {
    return Axios.post<ApiResultModel<IGetLoanTemplatesResponse[]>>(
        APIBASE_URL + LOAN + '/GetLoanTemplates',
        data
    ).then((result) => {
        return result.data.data;
    });
};
export const GetInProgressLoanTemplate = (data: {
    loanTemplateKey: string;
}): Promise<ApiResultModel<IGetInProgressLoanTemplateResponse>> => {
    return Axios.post<ApiResultModel<IGetInProgressLoanTemplateResponse>>(
        APIBASE_URL + LOAN + '/GetInProgressLoanTemplate',
        data
    ).then((result) => {
        return result.data;
    });
};
